import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { Input } from 'components/common/FormElements/Input'
import * as UI from './FormStyles'
import { EMAIL_HINT_ID } from '../../constants'

const Emails = ({ notes, form, ...props }) =>
  <React.Fragment>
    <UI.Row>
      <UI.Cell>
        <Field
          data-at-createaccountform-email-input
          { ...props }
          { ...form.email }
          full
          static
          component={ Input } />
      </UI.Cell>
      <EmailHintCell>
        <UserNameNotes id={ EMAIL_HINT_ID }>{ notes }</UserNameNotes>
      </EmailHintCell>
    </UI.Row>
  </React.Fragment>

Emails.propTypes = {
  form: PropTypes.shape({
    email: PropTypes.shape()
  }),
  notes: PropTypes.string
}

export default Emails

const EmailHintCell = styled(UI.Cell)`
  && {
    width: auto;
  }
`

const UserNameNotes = styled.span`
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBook(12, 400)}
`
